module.exports = __webpack_public_path__ + "static/charlize-theron-f0c59ce88a8912aa0540565bc2f9d38e.jpg";